import { trpc } from "./base";

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const useDatoStringByKey = (key: string) => {
  return trpc.useQuery(["getStringByKey", { key }]);
};
